/* eslint-disable */
import * as React from 'react';
import {
  Badge, Box, Button, Collapse, Divider, Flex, FormControl, FormLabel, HStack, Icon, IconButton,
  Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalOverlay,
  Select, SimpleGrid, Stack, Table, Tbody, Td, Text, Th, Thead, Tooltip,
  Tr, useColorModeValue, useDisclosure, useToast,
} from '@chakra-ui/react';
import {
  AutoComplete, AutoCompleteInput, AutoCompleteItem, AutoCompleteList,
} from '@choc-ui/chakra-autocomplete';
import {
  ColumnFiltersState, PaginationState, createColumnHelper, flexRender,
  getCoreRowModel, getFacetedMinMaxValues, getFacetedRowModel, getFacetedUniqueValues,
  getFilteredRowModel, getPaginationRowModel, getSortedRowModel, useReactTable,
} from '@tanstack/react-table';
import { useForm } from 'react-hook-form';
import {
  MdAdd, MdAttachFile, MdChevronLeft, MdChevronRight, MdDelete, MdFilterList,
  MdImage, MdReceipt, MdRefresh, MdShoppingCart, MdStorefront,
} from 'react-icons/md';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import Invoice from './orderDetails';

type RowObj = {
  id: number; Provedor: any; TipoCuenta: string; Total: number; createdAt: string;
};

const inputStyle = {
  variant: 'filled' as const,
  borderRadius: 'lg',
  _focus: { bg: 'white', borderColor: 'brand.500', boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)' },
};

export default function SearchTableOrders(props: { tableData: any }) {
  const { tableData } = props;
  const toast = useToast();
  const filterBg = useColorModeValue('gray.50', 'navy.900');
  const textColor = useColorModeValue('navy.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const brandColor = useColorModeValue('brand.500', 'brand.400');
  const rowHover = useColorModeValue('gray.50', 'whiteAlpha.50');

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [orden, setOrden] = React.useState(0);
  const { isOpen: isOpenNuevo, onOpen: onOpenNuevo, onClose: onCloseNuevo } = useDisclosure();

  const [showFilters, setShowFilters] = React.useState(false);
  const [tipoFilter, setTipoFilter] = React.useState('');
  const [fechaDesde, setFechaDesde] = React.useState('');
  const [fechaHasta, setFechaHasta] = React.useState('');
  const [totalMin, setTotalMin] = React.useState('');
  const [totalMax, setTotalMax] = React.useState('');

  const activeFilters = [!!tipoFilter, !!(fechaDesde || fechaHasta), !!(totalMin || totalMax)].filter(Boolean).length;
  const resetFilters = () => { setTipoFilter(''); setFechaDesde(''); setFechaHasta(''); setTotalMin(''); setTotalMax(''); };

  const [data, setData] = React.useState<RowObj[]>(() => [...tableData]);
  const [globalFilter, setGlobalFilter] = React.useState('');
  const [columnFilters, setColumnFilters] = React.useState<ColumnFiltersState>([]);
  const [{ pageIndex, pageSize }, setPagination] = React.useState<PaginationState>({ pageIndex: 0, pageSize: 8 });
  const pagination = React.useMemo(() => ({ pageIndex, pageSize }), [pageIndex, pageSize]);

  const filteredData = React.useMemo(() => data.filter((r) => {
    if (tipoFilter && r.TipoCuenta !== tipoFilter) return false;
    if (fechaDesde || fechaHasta) {
      const d = r.createdAt ? new Date(r.createdAt) : null;
      if (!d) return false;
      if (fechaDesde && d < new Date(fechaDesde)) return false;
      if (fechaHasta && d > new Date(fechaHasta + 'T23:59:59')) return false;
    }
    if (totalMin && r.Total < parseFloat(totalMin)) return false;
    if (totalMax && r.Total > parseFloat(totalMax)) return false;
    return true;
  }), [data, tipoFilter, fechaDesde, fechaHasta, totalMin, totalMax]);

  const uniqueTipos = React.useMemo(() => [...new Set(data.map((r) => r.TipoCuenta).filter(Boolean))].sort(), [data]);

  const totalGeneral = React.useMemo(() => filteredData.reduce((s, r) => s + (r.Total || 0), 0), [filteredData]);

  const { handleSubmit, register, reset, formState: { isSubmitting } } = useForm();
  const [provSelec, setProvSelec] = React.useState('');
  const [proveedores, setProveedores] = React.useState<any[]>([]);
  const fileRefEvi = React.useRef<HTMLInputElement>(null);
  const fileRefFact = React.useRef<HTMLInputElement>(null);
  const [fileEvi, setFileEvi] = React.useState<File | null>(null);
  const [fileFact, setFileFact] = React.useState<File | null>(null);

  type LineItem = { Articulo: string; Cantidad: number; Precio: number };
  const emptyLine = (): LineItem => ({ Articulo: '', Cantidad: 1, Precio: 0 });
  const [lineas, setLineas] = React.useState<LineItem[]>([emptyLine()]);

  const totalLineas = React.useMemo(
    () => lineas.reduce((s, l) => s + (l.Cantidad || 0) * (l.Precio || 0), 0),
    [lineas]
  );

  const updateLinea = (i: number, field: keyof LineItem, val: string) => {
    setLineas(prev => prev.map((l, idx) => idx === i ? { ...l, [field]: field === 'Articulo' ? val : parseFloat(val) || 0 } : l));
  };

  React.useEffect(() => {
    fetch(process.env.REACT_APP_URL_SERVER + '/proveedores', { credentials: 'include' }).then(r => r.json()).then(setProveedores).catch(() => {});
  }, []);

  const refreshTable = async () => {
    const d = await fetch(process.env.REACT_APP_URL_SERVER + '/compras', { credentials: 'include' }).then(r => r.json()).catch(() => null);
    if (d) setData(d);
  };

  const onSubmitNuevo = async (values: any) => {
    if (!provSelec) { toast({ title: 'Selecciona un proveedor', status: 'warning', duration: 3000 }); return; }
    if (lineas.some(l => !l.Articulo)) { toast({ title: 'Completa el artículo de cada línea', status: 'warning', duration: 3000 }); return; }
    const fd = new FormData();
    fd.append('Fecha', values.Fecha);
    fd.append('TipoCuenta', values.TipoCuenta);
    fd.append('idProveedor', provSelec);
    const lineasPayload = lineas.map(l => ({
      Articulo: l.Articulo,
      Cantidad: l.Cantidad,
      Descripcion: l.Articulo,
      Precio: l.Precio,
      Total: l.Cantidad * l.Precio,
    }));
    fd.append('Lineas', JSON.stringify(lineasPayload));
    if (fileEvi) fd.append('Evidencia', fileEvi);
    if (fileFact) fd.append('Factura', fileFact);
    const res = await fetch(process.env.REACT_APP_URL_SERVER + '/new_shop', { method: 'POST', body: fd, credentials: 'include' });
    if (res.ok) {
      toast({ title: 'Compra registrada', status: 'success', duration: 3000 });
      reset(); setProvSelec(''); setFileEvi(null); setFileFact(null);
      setLineas([emptyLine()]); onCloseNuevo(); await refreshTable();
    } else {
      toast({ title: 'Error al guardar', status: 'error', duration: 3000 });
    }
  };

  const columnHelper = createColumnHelper<RowObj>();
  const columns = [
    columnHelper.accessor('Provedor', {
      id: 'proveedor',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">PROVEEDOR</Text>,
      cell: (info) => (
        <Box>
          <Text color={textColor} fontWeight="600" fontSize="sm">{info.getValue()?.RazonSocial || '—'}</Text>
          <Text color="gray.400" fontSize="xs">Compra #{info.row.original.id}</Text>
        </Box>
      ),
    }),
    columnHelper.accessor('TipoCuenta', {
      id: 'tipo',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">TIPO DE GASTO</Text>,
      cell: (info) => <Badge colorScheme="blue" fontSize="xs" borderRadius="md" px="2">{info.getValue()}</Badge>,
    }),
    columnHelper.accessor('createdAt', {
      id: 'fecha',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">FECHA</Text>,
      cell: (info) => {
        const v = info.getValue();
        return <Text color="gray.500" fontSize="xs">{v ? new Date(v).toLocaleString('es-MX', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—'}</Text>;
      },
    }),
    columnHelper.accessor('Total', {
      id: 'total',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">TOTAL</Text>,
      cell: (info) => <Text color={textColor} fontWeight="700" fontSize="sm">${(info.getValue() || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Text>,
    }),
    columnHelper.accessor('id', {
      id: 'actions',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">ACCIONES</Text>,
      cell: (info) => (
        <Tooltip label="Ver detalle">
          <IconButton
            aria-label="detalle"
            size="sm"
            variant="ghost"
            colorScheme="blue"
            icon={<Icon as={MdReceipt} h="18px" w="18px" />}
            onClick={() => { setOrden(info.getValue()); onOpen(); }}
          />
        </Tooltip>
      ),
    }),
  ];

  const table = useReactTable({
    data: filteredData, columns,
    state: { columnFilters, globalFilter, pagination },
    onPaginationChange: setPagination, onColumnFiltersChange: setColumnFilters, onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(), getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(), getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(), getFacetedUniqueValues: getFacetedUniqueValues(), getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });
  const createPages = (n: number) => Array.from({ length: n }, (_, i) => i + 1);

  return (
    <Flex direction="column" w="100%" overflowX={{ sm: 'scroll', lg: 'hidden' }}>
      <Flex align="center" justify="space-between" w="100%" px="22px" mb="16px" flexWrap="wrap" gap="10px">
        <DebouncedInput value={globalFilter ?? ''} onChange={(v) => setGlobalFilter(String(v))} placeholder="Buscar compra..." />
        <HStack spacing="8px">
          <Tooltip label="Actualizar">
            <IconButton aria-label="refresh" size="md" variant="outline" icon={<Icon as={MdRefresh} h="18px" w="18px" />} onClick={refreshTable} />
          </Tooltip>
          <Button variant="outline" fontSize="sm" leftIcon={<Icon as={MdFilterList} />} onClick={() => setShowFilters(v => !v)} position="relative">
            Filtros
            {activeFilters > 0 && (
              <Badge colorScheme="brand" borderRadius="full" position="absolute" top="-6px" right="-6px" fontSize="10px" minW="18px" h="18px" display="flex" alignItems="center" justifyContent="center">{activeFilters}</Badge>
            )}
          </Button>
          <Button variant="brand" fontSize="sm" fontWeight="500" onClick={onOpenNuevo}>+ Nueva Compra</Button>
        </HStack>
      </Flex>

      {/* Total banner */}
      <Flex px="22px" mb="12px" gap="8px" align="center">
        <Text fontSize="sm" color="gray.500">Total filtrado:</Text>
        <Badge colorScheme="teal" fontSize="sm" px="3" py="1" borderRadius="full">${totalGeneral.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</Badge>
        {uniqueTipos.map(t => (
          <Badge
            key={t}
            colorScheme={tipoFilter === t ? 'blue' : 'gray'}
            variant={tipoFilter === t ? 'solid' : 'outline'}
            fontSize="xs" px="3" py="1" borderRadius="full" cursor="pointer"
            onClick={() => { setTipoFilter(tipoFilter === t ? '' : t); setPagination(p => ({ ...p, pageIndex: 0 })); }}
            _hover={{ opacity: 0.8 }} userSelect="none"
          >{t}</Badge>
        ))}
        {activeFilters > 0 && (
          <Badge colorScheme="orange" variant="outline" fontSize="xs" px="3" py="1" borderRadius="full" cursor="pointer" onClick={resetFilters} _hover={{ opacity: 0.8 }}>✕ Limpiar</Badge>
        )}
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Box mx="22px" mb="16px" p="16px" bg={filterBg} borderRadius="12px" border="1px solid" borderColor={borderColor}>
          <Text fontSize="sm" fontWeight="700" color={textColor} mb="14px">Filtros avanzados</Text>
          <SimpleGrid columns={{ base: 1, md: 3 }} gap="16px">
            <Box>
              <FormLabel fontSize="xs" fontWeight="600" color="gray.500" mb="6px">TIPO DE GASTO</FormLabel>
              <Select size="sm" borderRadius="8px" value={tipoFilter} onChange={(e) => { setTipoFilter(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }}>
                <option value="">Todos</option>
                {uniqueTipos.map(t => <option key={t} value={t}>{t}</option>)}
              </Select>
            </Box>
            <Box>
              <FormLabel fontSize="xs" fontWeight="600" color="gray.500" mb="6px">FECHA</FormLabel>
              <HStack spacing="8px">
                <Input size="sm" type="date" borderRadius="8px" value={fechaDesde} onChange={(e) => { setFechaDesde(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }} />
                <Text fontSize="xs" color="gray.400">al</Text>
                <Input size="sm" type="date" borderRadius="8px" value={fechaHasta} onChange={(e) => { setFechaHasta(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }} />
              </HStack>
            </Box>
            <Box>
              <FormLabel fontSize="xs" fontWeight="600" color="gray.500" mb="6px">RANGO DE MONTO ($)</FormLabel>
              <HStack spacing="8px">
                <Input size="sm" type="number" borderRadius="8px" placeholder="Mín" value={totalMin} onChange={(e) => { setTotalMin(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }} />
                <Text fontSize="xs" color="gray.400">—</Text>
                <Input size="sm" type="number" borderRadius="8px" placeholder="Máx" value={totalMax} onChange={(e) => { setTotalMax(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }} />
              </HStack>
            </Box>
          </SimpleGrid>
          <Flex mt="14px" justify="flex-end">
            <Button size="sm" variant="ghost" colorScheme="red" onClick={resetFilters}>Limpiar</Button>
          </Flex>
        </Box>
      </Collapse>
      {activeFilters > 0 && (
        <Text px="22px" mb="8px" fontSize="xs" color="gray.500">Mostrando <strong>{filteredData.length}</strong> de {data.length}</Text>
      )}

      {/* Invoice detail modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside" motionPreset="slideInBottom">
        <ModalOverlay backdropFilter="blur(4px)" bg="blackAlpha.400" />
        <ModalContent borderRadius="2xl" overflow="hidden" mx={4}>
          <Box bg="teal.500" px={6} py={4}>
            <HStack justify="space-between" align="center">
              <HStack gap={3}>
                <Icon as={MdReceipt} color="white" w={5} h={5} />
                <Text color="white" fontWeight="700" fontSize="lg">Compra #{orden}</Text>
              </HStack>
              <ModalCloseButton position="static" color="white" _hover={{ bg: 'whiteAlpha.300' }} borderRadius="lg" />
            </HStack>
          </Box>
          <ModalBody px={6} py={5}>
            <Invoice id={orden} />
          </ModalBody>
          <ModalFooter borderTop="1px solid" borderColor="gray.100" gap={3} px={6} py={4}>
            <Button variant="ghost" borderRadius="xl" onClick={onClose}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Nueva Compra modal */}
      <Modal isOpen={isOpenNuevo} onClose={() => { reset(); setProvSelec(''); setLineas([emptyLine()]); setFileEvi(null); setFileFact(null); onCloseNuevo(); }} size="4xl" scrollBehavior="inside" motionPreset="slideInBottom">
        <ModalOverlay backdropFilter="blur(4px)" bg="blackAlpha.400" />
        <ModalContent borderRadius="2xl" overflow="hidden" mx={4}>

          {/* Header */}
          <Box bg="brand.500" px={6} py={4}>
            <HStack justify="space-between" align="center">
              <HStack gap={3}>
                <Icon as={MdShoppingCart} color="white" w={5} h={5} />
                <Text color="white" fontWeight="700" fontSize="lg">Registrar Nueva Compra</Text>
              </HStack>
              <ModalCloseButton position="static" color="white" _hover={{ bg: 'whiteAlpha.300' }} borderRadius="lg" />
            </HStack>
          </Box>

          <form onSubmit={handleSubmit(onSubmitNuevo)}>
            <ModalBody px={6} py={6}>

              {/* Sección: Información General */}
              <HStack mb={3}>
                <Icon as={MdStorefront} color="brand.500" w={4} h={4} />
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="brand.500">
                  Información General
                </Text>
                <Divider />
              </HStack>

              <SimpleGrid columns={{ base: 1, md: 2 }} gap={4} mb={5}>
                <FField label="Proveedor">
                  <AutoComplete openOnFocus onChange={(val: any) => setProvSelec(String(val))}>
                    <AutoCompleteInput
                      variant="filled"
                      borderRadius="lg"
                      placeholder="Buscar proveedor..."
                      _focus={{ bg: 'white', borderColor: 'brand.500', boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)' }}
                    />
                    <AutoCompleteList>
                      {proveedores.length === 0
                        ? <Box px={4} py={3} fontSize="sm" color="gray.400">Sin proveedores registrados</Box>
                        : proveedores.map((p: any) => (
                            <AutoCompleteItem key={`prov-${p.id}`} label={p.RazonSocial || `${p.Nombre} ${p.ApellidoPaterno}`} value={String(p.id)}>
                              <Box>
                                <Text fontSize="sm" fontWeight="600">{p.RazonSocial || `${p.Nombre} ${p.ApellidoPaterno}`}</Text>
                                {p.RFC && <Text fontSize="xs" color="gray.400">{p.RFC}</Text>}
                              </Box>
                            </AutoCompleteItem>
                          ))}
                    </AutoCompleteList>
                  </AutoComplete>
                </FField>
                <FField label="Fecha de Compra">
                  <Input type="date" {...register('Fecha', { required: true })} {...inputStyle} />
                </FField>
                <FField label="Tipo de Gasto">
                  <Input placeholder="Propaganda, Logística, Imprenta…" {...register('TipoCuenta', { required: true })} {...inputStyle} />
                </FField>
              </SimpleGrid>

              {/* Sección: Líneas de Compra */}
              <HStack mb={3}>
                <Icon as={MdReceipt} color="brand.500" w={4} h={4} />
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="brand.500">
                  Líneas de Compra
                </Text>
                <Divider />
              </HStack>

              <Box mb={4} borderRadius="xl" border="1px solid" borderColor={borderColor} overflow="hidden">
                {/* Table header */}
                <SimpleGrid columns={4} gap={0} bg={filterBg} px={3} py={2}>
                  {['Artículo / Concepto', 'Cantidad', 'Precio Unit.', 'Total'].map(h => (
                    <Text key={h} fontSize="10px" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="gray.500">{h}</Text>
                  ))}
                </SimpleGrid>

                {lineas.map((l, i) => (
                  <HStack key={i} px={3} py={2} gap={2} borderTop="1px solid" borderColor={borderColor} align="center">
                    <Input
                      flex={2}
                      size="sm"
                      placeholder="Descripción del artículo"
                      value={l.Articulo}
                      onChange={(e) => updateLinea(i, 'Articulo', e.target.value)}
                      {...inputStyle}
                    />
                    <Input
                      flex={1}
                      size="sm"
                      type="number"
                      min={1}
                      placeholder="1"
                      value={l.Cantidad}
                      onChange={(e) => updateLinea(i, 'Cantidad', e.target.value)}
                      {...inputStyle}
                    />
                    <Input
                      flex={1}
                      size="sm"
                      type="number"
                      step="0.01"
                      min={0}
                      placeholder="0.00"
                      value={l.Precio}
                      onChange={(e) => updateLinea(i, 'Precio', e.target.value)}
                      {...inputStyle}
                    />
                    <Text flex={1} fontSize="sm" fontWeight="700" color={textColor}>
                      ${((l.Cantidad || 0) * (l.Precio || 0)).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                    </Text>
                    <IconButton
                      aria-label="eliminar línea"
                      size="sm"
                      variant="ghost"
                      colorScheme="red"
                      icon={<Icon as={MdDelete} />}
                      isDisabled={lineas.length === 1}
                      onClick={() => setLineas(prev => prev.filter((_, idx) => idx !== i))}
                    />
                  </HStack>
                ))}

                {/* Add line + total */}
                <Flex px={3} py={3} justify="space-between" align="center" borderTop="1px solid" borderColor={borderColor} bg={filterBg}>
                  <Button size="sm" variant="outline" colorScheme="brand" leftIcon={<Icon as={MdAdd} />} borderRadius="lg" onClick={() => setLineas(prev => [...prev, emptyLine()])}>
                    Agregar línea
                  </Button>
                  <HStack gap={2}>
                    <Text fontSize="sm" color="gray.500">Total:</Text>
                    <Badge colorScheme="teal" fontSize="sm" px={3} py={1} borderRadius="full">
                      ${totalLineas.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                    </Badge>
                  </HStack>
                </Flex>
              </Box>

              {/* Sección: Documentos */}
              <HStack mb={3}>
                <Icon as={MdAttachFile} color="brand.500" w={4} h={4} />
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="brand.500">
                  Documentos
                </Text>
                <Divider />
              </HStack>

              <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
                <FField label="Evidencia (foto)">
                  <Box
                    border="2px dashed"
                    borderColor={fileEvi ? 'brand.400' : borderColor}
                    borderRadius="xl"
                    p={3}
                    cursor="pointer"
                    _hover={{ borderColor: 'brand.400', bg: 'brand.50' }}
                    onClick={() => fileRefEvi.current?.click()}
                    transition="all 0.2s"
                  >
                    <HStack gap={3}>
                      <Icon as={MdImage} w={6} h={6} color={fileEvi ? 'brand.500' : 'gray.300'} />
                      <Box>
                        <Text fontSize="sm" fontWeight="600" color={fileEvi ? textColor : 'gray.400'}>
                          {fileEvi?.name || 'Seleccionar imagen'}
                        </Text>
                        <Text fontSize="xs" color="gray.400">JPG, PNG</Text>
                      </Box>
                    </HStack>
                  </Box>
                  <input ref={fileRefEvi} type="file" accept=".jpg,.jpeg,.png" style={{ display: 'none' }} onChange={(e) => setFileEvi(e.target.files?.[0] || null)} />
                </FField>

                <FField label="Factura (PDF)">
                  <Box
                    border="2px dashed"
                    borderColor={fileFact ? 'brand.400' : borderColor}
                    borderRadius="xl"
                    p={3}
                    cursor="pointer"
                    _hover={{ borderColor: 'brand.400', bg: 'brand.50' }}
                    onClick={() => fileRefFact.current?.click()}
                    transition="all 0.2s"
                  >
                    <HStack gap={3}>
                      <Icon as={MdAttachFile} w={6} h={6} color={fileFact ? 'brand.500' : 'gray.300'} />
                      <Box>
                        <Text fontSize="sm" fontWeight="600" color={fileFact ? textColor : 'gray.400'}>
                          {fileFact?.name || 'Seleccionar PDF'}
                        </Text>
                        <Text fontSize="xs" color="gray.400">PDF</Text>
                      </Box>
                    </HStack>
                  </Box>
                  <input ref={fileRefFact} type="file" accept=".pdf" style={{ display: 'none' }} onChange={(e) => setFileFact(e.target.files?.[0] || null)} />
                </FField>
              </SimpleGrid>

            </ModalBody>

            <ModalFooter borderTop="1px solid" borderColor="gray.100" gap={3} px={6} py={4} justifyContent="space-between">
              <HStack gap={2}>
                <Text fontSize="sm" color="gray.500">Total a registrar:</Text>
                <Badge colorScheme="teal" fontSize="md" px={3} py={1} borderRadius="full" fontWeight="700">
                  ${totalLineas.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                </Badge>
              </HStack>
              <HStack gap={3}>
                <Button variant="ghost" borderRadius="xl" onClick={() => { reset(); setProvSelec(''); setLineas([emptyLine()]); setFileEvi(null); setFileFact(null); onCloseNuevo(); }}>
                  Cancelar
                </Button>
                <Button colorScheme="brand" type="submit" isLoading={isSubmitting} borderRadius="xl" px={8} leftIcon={<Icon as={MdShoppingCart} />}>
                  Registrar Compra
                </Button>
              </HStack>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>

      <Table variant="simple" color="gray.500" mb="24px">
        <Thead>
          {table.getHeaderGroups().map(hg => (
            <Tr key={hg.id}>
              {hg.headers.map(h => (
                <Th pe="10px" borderColor={borderColor} key={h.id} colSpan={h.colSpan}>
                  {h.isPlaceholder ? null : (
                    <Flex justify="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" cursor={h.column.getCanSort() ? 'pointer' : 'default'} onClick={h.column.getToggleSortingHandler()}>
                      {flexRender(h.column.columnDef.header, h.getContext())}
                    </Flex>
                  )}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody>
          {table.getRowModel().rows.length === 0
            ? (<Tr><Td colSpan={columns.length} textAlign="center" py="40px" color="gray.400">Sin registros</Td></Tr>)
            : table.getRowModel().rows.map(row => (
                <Tr key={row.id} _hover={{ bg: rowHover }}>
                  {row.getVisibleCells().map(cell => (
                    <Td key={cell.id} fontSize={{ sm: '14px' }} minW={{ sm: '120px', md: 'auto' }} borderColor={borderColor} py="12px">
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </Td>
                  ))}
                </Tr>
              ))}
        </Tbody>
      </Table>

      <Flex w="100%" justify="space-between" px="20px" pt="10px" pb="5px">
        <Text fontSize="sm" color="gray.500" mb={{ sm: '24px', md: '0px' }}>
          {filteredData.length === 0 ? 'Sin registros' : `${pageSize * pageIndex + 1}–${Math.min(pageSize * (pageIndex + 1), filteredData.length)} de ${filteredData.length}`}
        </Text>
        <Stack direction="row" alignSelf="flex-end" spacing="4px" ms="auto">
          <Button variant="no-effects" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()} w="40px" h="40px" borderRadius="50%" bg="transparent" border="1px solid" borderColor={borderColor} display={table.getCanPreviousPage() ? 'flex' : 'none'} _hover={{ opacity: '0.7' }}>
            <Icon as={MdChevronLeft} w="16px" h="16px" color={textColor} />
          </Button>
          {createPages(table.getPageCount()).map((p, i) => (
            <Button key={i} variant="no-effects" onClick={() => table.setPageIndex(p - 1)} w="40px" h="40px" borderRadius="50%" bg={p === pageIndex + 1 ? brandColor : 'transparent'} border={p === pageIndex + 1 ? 'none' : '1px solid lightgray'} _hover={p === pageIndex + 1 ? { opacity: '0.7' } : { bg: 'whiteAlpha.100' }}>
              <Text fontSize="sm" color={p === pageIndex + 1 ? '#fff' : textColor}>{p}</Text>
            </Button>
          ))}
          <Button variant="no-effects" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()} w="40px" h="40px" borderRadius="50%" bg="transparent" border="1px solid" borderColor={borderColor} display={table.getCanNextPage() ? 'flex' : 'none'} _hover={{ opacity: '0.7' }}>
            <Icon as={MdChevronRight} w="16px" h="16px" color={textColor} />
          </Button>
        </Stack>
      </Flex>
    </Flex>
  );
}

function FField({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <FormControl>
      <FormLabel fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="gray.500" mb={1}>{label}</FormLabel>
      {children}
    </FormControl>
  );
}

function DebouncedInput({ value: iv, onChange, debounce = 500, ...props }: { value: string | number; onChange: (v: string | number) => void; debounce?: number } & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const [value, setValue] = React.useState(iv);
  React.useEffect(() => { setValue(iv); }, [iv]);
  React.useEffect(() => { const t = setTimeout(() => onChange(value), debounce); return () => clearTimeout(t); }, [value]);
  return <SearchBar {...props} value={value} onChange={(e: any) => setValue(e.target.value)} h="44px" w={{ lg: '390px' }} borderRadius="16px" />;
}
